import { CircleQuestionMark } from 'lucide-react';
export const NotFoundComponent = ({
    customNotFound,
}: {
    customNotFound?: string;
}) => {
    return (
        <div className="gap-2 flex flex-col items-center justify-center">
            <div className="flex gap-2 w-full self-center items-center justify-center m-auto flex-row">
                <CircleQuestionMark className="text-primary" size={48} />
                <div className="border-l-2 border-secondary-light p-2">
                    <p className="text-2xl text-secondary-foreground">
                        {customNotFound || 'Not Found'}
                    </p>
                </div>
            </div>
        </div>
    );
};

export const DefaultNotFound = ({
    customNotFound,
}: {
    customNotFound?: string;
}) => {
    return (
        <div className="bg-background-dark w-full min-h-[calc(100vh-150px)] p-4 rounded-2xl flex flex-col items-center justify-center">
            <NotFoundComponent customNotFound={customNotFound} />
        </div>
    );
};
